import {
    type EmploymentType,
    type IndustryType,
} from '../../banking/types/Edd';
import { requestBuilder } from '../../http/RequestBuilder';

export interface CustomerEdd {
    employmentType: EmploymentType;
    occupationIndustry: IndustryType;
}

export const useCreateEdd = requestBuilder.mutation<
    { success: true },
    CustomerEdd,
    { userId: string }
>({
    endpoint: ({ userId }) => `/api/user/${userId}/edd`,
    method: 'POST',
});
